// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"717c7ecb","211":"a49f09f7","238":"f3ce311b","403":"985fae5b","409":"e96f5fb6"}[chunkId] + ".chunk.js";
};